/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLoggedInUser } from '../fn/security/get-logged-in-user';
import { GetLoggedInUser$Params } from '../fn/security/get-logged-in-user';
import { login } from '../fn/security/login';
import { Login$Params } from '../fn/security/login';
import { logout } from '../fn/security/logout';
import { Logout$Params } from '../fn/security/logout';
import { requestResetPassword } from '../fn/security/request-reset-password';
import { RequestResetPassword$Params } from '../fn/security/request-reset-password';
import { resetPassword } from '../fn/security/reset-password';
import { ResetPassword$Params } from '../fn/security/reset-password';
import { LoginResponse as SecurityLoginResponse } from '../models/security/login-response';
import { UserDto as SecurityUserDto } from '../models/security/user-dto';

@Injectable({ providedIn: 'root' })
export class SecurityClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `securityLogin()` */
  static readonly SecurityLoginPath = '/security/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login$Response(body: Login$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<SecurityLoginResponse>> {
    const obs = login(this.http, this.rootUrl, { body } satisfies Login$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login(body: Login$Params['body'], context?: HttpContext): Observable<SecurityLoginResponse> {
    const resp = this.login$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SecurityLoginResponse>): SecurityLoginResponse => r.body)
    );
  }

  /** Path part for operation `securityLogout()` */
  static readonly SecurityLogoutPath = '/security/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logout()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout$Response(context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = logout(this.http, this.rootUrl, {} satisfies Logout$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout(context?: HttpContext): Observable<void> {
    const resp = this.logout$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `securityGetLoggedInUser()` */
  static readonly SecurityGetLoggedInUserPath = '/security/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoggedInUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoggedInUser$Response(context?: HttpContext): Observable<StrictHttpResponse<SecurityUserDto>> {
    const obs = getLoggedInUser(this.http, this.rootUrl, {} satisfies GetLoggedInUser$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoggedInUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoggedInUser(context?: HttpContext): Observable<SecurityUserDto> {
    const resp = this.getLoggedInUser$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<SecurityUserDto>): SecurityUserDto => r.body)
    );
  }

  /** Path part for operation `securityResetPassword()` */
  static readonly SecurityResetPasswordPath = '/security/reset-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetPassword$Response(body: ResetPassword$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = resetPassword(this.http, this.rootUrl, { body } satisfies ResetPassword$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetPassword(body: ResetPassword$Params['body'], context?: HttpContext): Observable<void> {
    const resp = this.resetPassword$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `securityRequestResetPassword()` */
  static readonly SecurityRequestResetPasswordPath = '/security/request-password-reset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestResetPassword$Response(body: RequestResetPassword$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = requestResetPassword(this.http, this.rootUrl, { body } satisfies RequestResetPassword$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestResetPassword(body: RequestResetPassword$Params['body'], context?: HttpContext): Observable<void> {
    const resp = this.requestResetPassword$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
